import { render, staticRenderFns } from "./ClinicOrderRequestList.vue?vue&type=template&id=5476481a&scoped=true&"
import script from "./ClinicOrderRequestList.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOrderRequestList.vue?vue&type=style&index=0&id=5476481a&prod&lang=scss&scoped=true&"
import style1 from "./ClinicOrderRequestList.vue?vue&type=style&index=1&id=5476481a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476481a",
  null
  
)

export default component.exports